import { render } from "./TemplateMainInfo.vue?vue&type=template&id=d476455e&scoped=true"
import script from "./TemplateMainInfo.vue?vue&type=script&lang=js"
export * from "./TemplateMainInfo.vue?vue&type=script&lang=js"

import "./TemplateMainInfo.vue?vue&type=style&index=0&id=d476455e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d476455e"]])

export default __exports__